import React from 'react';
import HeroSlider from '@/components/site/HeroSlider';
import { StatsStrip, PlatformSection, IndustriesSection, ContextSection, ServicesSection, CTASection } from '@/components/site/Sections';
import DeployedSection from '@/components/site/DeployedSection';

export default function HomePage() {
  return (
    <>
      <HeroSlider />
      <StatsStrip />
      <PlatformSection />
      <IndustriesSection />
      <ContextSection />
      <ServicesSection />
      <DeployedSection />
      <CTASection />
    </>
  );
}
